import Vue from 'vue'
import FileDown from '@/views/mobile/components/fileDown.vue'
Vue.component('fileDown', FileDown)
